module.exports=function(scope){ return `<div id="asseco-audiochat-window-audio-panel">
    <button class="mdl-button mdl-button--fab mdl-button--mini-fab audio-btn">
        ${scope.audioBtnOn}
    </button>

    ${scope.audioTxt}

    <audio id="asseco-audiochat-window-audio-local" autoplay="autoplay" muted="true" src=""></audio>
    <audio id="asseco-audiochat-window-audio-remote" autoplay="autoplay" src=""></audio>
</div>`};